module.exports = __webpack_public_path__ + "static/media/soft2.6ccedf52.png";